import {
    GET_LOGGED_USER_DETAILS
} from '../ActionTypes/ActionTypes';


const initialState = {
    loggedUser: {}
};
function UserReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {


        case GET_LOGGED_USER_DETAILS:
            return {
                ...state, 
                loggedUser: payload,
            };

        default:
            return state;
    }
};

export default UserReducer;